import React from 'react';
import { Slider } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const RatingSlider = props => {
  const CustomSliderTheme = createTheme({
    overrides: {
      MuiSlider: {
        root: {
          color: '#4FB2CD',
          marginBottom: '20px',
          width: '80%',
          height: 8
        },
        thumb: {
          height: 24,
          width: 24,
          backgroundColor: '#5DCDE7',
          border: '1px solid #5DCDE7',
          marginTop: -8,
          marginLeft: -12,
          '&:focus, &:hover, &$active': {
            boxShadow: 'inherit'
          }
        },
        active: {},
        valueLabel: {
          left: 'calc(-50% + 6px)'
        },
        track: {
          height: 8,
          borderRadius: 4
        },
        rail: {
          height: 8,
          borderRadius: 4
        },
        mark: {
          display: 'none'
        },
        markLabel: {
          top: '30px'
        }
      }
    }
  });

  return (
    <ThemeProvider theme={ CustomSliderTheme }>
      <Slider
        step={ 1 }
        min= { 0 }
        type="number"
        { ...props }
      />
    </ThemeProvider>
  );
};

export default RatingSlider;
